<template>
  <!-- Rendering handled by RenderComponents; this is a pass-through wrapper -->
  <slot />
</template>

<script setup lang="ts">
import type { SharedNodeRefFields } from './definition'
defineProps<{
  fields: SharedNodeRefFields
}>()
</script>
